import FsLightbox from 'fslightbox-react'
import { useState } from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'


export default function Tipologia({
                                      preText = 'Disponibilità',
                                      titolo,
                                      text,
                                      folder,
                                      data = {},
                                      children,
                                      appointment,
                                  }) {
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1,
    })

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number,
        })
    }

    const scrollToSection = (tgt) => {
        tgt.current?.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <div className="relative isolate overflow-hidden py-24 sm:py-32 lg:overflow-visible lg:px-0">
            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
                <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
                    <div className="lg:pr-4">
                        <div className="lg:max-w-lg">
                            <p className="text-base/7 font-semibold text-teal-600">{preText}</p>
                            <h1 className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                                {titolo}
                            </h1>
                            <p className="mt-6 text-xl/8 text-gray-700">
                                {text}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="lg:-ml-12 -mt-12 lg:p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
                    <Carousel
                        infiniteLoop={true}
                        autoPlay={true}
                        className=""
                    >
                        <div
                            className="cursor-pointer"
                            onClick={() => openLightboxOnSlide(2)}
                        >
                            <img
                                src={'/images/' + folder + '/main.jpeg'}
                                alt={titolo}
                                className="w-[48rem] max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
                            />
                            <p className="legend">{titolo}</p>
                        </div>
                        <div
                            className="cursor-pointer"
                            onClick={() => openLightboxOnSlide(3)}
                        >
                            <img
                                src={'/images/' + folder + '/01.jpeg'}
                                alt={titolo}
                                className="w-[48rem] max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
                            />
                            <p className="legend">{titolo}</p>
                        </div>
                        <div
                            className="cursor-pointer"
                            onClick={() => openLightboxOnSlide(4)}
                        >
                            <img
                                src={'/images/' + folder + '/02.jpeg'}
                                alt={titolo}
                                className="w-[48rem] max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
                            />
                            <p className="legend">{titolo}</p>
                        </div>
                    </Carousel>
                </div>
                <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
                    <div className="lg:pr-4">
                        <div className="max-w-xl text-base/7 text-gray-700 lg:max-w-lg">
                            <ul
                                role="list"
                                className="mt-8 space-y-4 text-gray-600"
                            >
                                <li className="flex gap-x-1">
                                    <strong className="font-semibold text-gray-900">Dimensioni:</strong> {data.mq} mq
                                </li>
                                {titolo === 'Attici' && (
                                    <>
                                        <li className="ml-2">
                                            <strong className="font-semibold text-gray-900">Ultimo piano:</strong> 132mq
                                            abitabili, 70 mq di terrazza
                                        </li>
                                        <li className="ml-2">
                                            <strong className="font-semibold text-gray-900">Sottotetto:</strong> 98mq
                                            abitabili,
                                            20 mq di terrazza
                                        </li>
                                    </>
                                )}
                                {data.balconi_mq && (
                                    <li className="flex gap-x-1">
                                        <strong className="font-semibold text-gray-900">Balconi/Terrazze:</strong> {data.balconi_mq} mq
                                    </li>
                                )}
                                {data.locali && (
                                    <li className="flex gap-x-1">
                                        <strong className="font-semibold text-gray-900">Locali:</strong> {data.locali}
                                    </li>
                                )}
                                {data.bagni && (
                                    <li className="flex gap-x-1">
                                        <strong className="font-semibold text-gray-900">Bagni:</strong> {data.bagni}
                                    </li>
                                )}
                                {data.balconi && (
                                    <li className="flex gap-x-1">
                                        <strong className="font-semibold text-gray-900">Balconi:</strong> {data.balconi}
                                    </li>
                                )}
                                <li className="flex gap-x-3">
                                    <strong className="font-semibold text-gray-900">Prezzo:</strong> {data.price ? `A partire da ${data.price}€` : 'Trattativa riservata'}
                                </li>
                            </ul>

                            <img
                                onClick={() => openLightboxOnSlide(1)}
                                src={'/images/' + folder + '/planimetria.jpeg'}
                                alt="Planimetria"
                                className="mt-6 cursor-pointer rounded-xl bg-gray-900 shadow-xl"
                            />
                            {titolo === 'Attici' && (
                                <img
                                    onClick={() => openLightboxOnSlide(2)}
                                    src={'/images/' + folder + '/planimetria2.jpeg'}
                                    alt="Planimetria"
                                    className="mt-6 cursor-pointer rounded-xl bg-gray-900 shadow-xl"
                                />
                            )}
                            <p className="mt-6">
                                {children}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center mt-16">
                <a
                    onClick={() => scrollToSection(appointment)}
                    className="cursor-pointer rounded-md bg-teal-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-teal-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400"
                >
                    Richiedi Appuntamento
                </a>
            </div>
            <FsLightbox
                toggler={lightboxController.toggler}
                sources={[
                    '/images/' + folder + '/planimetria.jpeg',
                    ...(titolo === 'Attici' ? [`/images/${folder}/planimetria2.jpeg`] : []),
                    '/images/' + folder + '/main.jpeg',
                    '/images/' + folder + '/01.jpeg',
                    '/images/' + folder + '/02.jpeg',
                ]}
                slide={lightboxController.slide}
            />
        </div>
    )
}
